import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface ColumnPrefsState {
  visibleColumns: string[]
  toggleColumn: (columnId: string) => void
  setVisibleColumns: (columns: string[]) => void
  moveColumn: (columnId: string, direction: 'up' | 'down') => void
  columnSizing: Record<string, number>
  setColumnSizing: (sizing: Record<string, number>) => void
}

const DEFAULT_COLUMNS = [
  'order_id',
  'customer_name',
  'reference',
  'app_status',
  'employee_id',
  'order_date',
]

export const useColumnPrefsStore = create<ColumnPrefsState>()(
  persist(
    (set) => ({
      visibleColumns: DEFAULT_COLUMNS,
      toggleColumn: (columnId) =>
        set((state) => {
          const isVisible = state.visibleColumns.includes(columnId)
          return {
            visibleColumns: isVisible
              ? state.visibleColumns.filter((c) => c !== columnId)
              : [...state.visibleColumns, columnId],
          }
        }),
      setVisibleColumns: (columns) => set({ visibleColumns: columns }),
      moveColumn: (columnId, direction) =>
        set((state) => {
          const cols = [...state.visibleColumns]
          const idx = cols.indexOf(columnId)
          if (idx === -1) return state
          const targetIdx = direction === 'up' ? idx - 1 : idx + 1
          if (targetIdx < 0 || targetIdx >= cols.length) return state
          ;[cols[idx], cols[targetIdx]] = [cols[targetIdx], cols[idx]]
          return { visibleColumns: cols }
        }),
      columnSizing: {},
      setColumnSizing: (sizing) => set({ columnSizing: sizing }),
    }),
    {
      name: 'admin-column-prefs',
    }
  )
)

export const DEFAULT_COLUMN_ORDER = DEFAULT_COLUMNS
